import { render, staticRenderFns } from "./allService.vue?vue&type=template&id=25e40c95&scoped=true&"
import script from "./allService.vue?vue&type=script&lang=js&"
export * from "./allService.vue?vue&type=script&lang=js&"
import style0 from "./allService.vue?vue&type=style&index=0&id=25e40c95&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e40c95",
  null
  
)

export default component.exports